





































































import InstitutionTopItem from './components/businessStatistics/InstitutionTopItem.vue';
import CountryDistribution from './components/businessStatistics/CountryDistribution.vue';
import SpecialtyDistribution from './components/businessStatistics/SpecialtyDistribution.vue';
import QsRankingDistribution from './components/businessStatistics/QsRankingDistribution.vue';
import ApplicationDistribution from './components/businessStatistics/ApplicationDistribution.vue';
import { AppModule } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user';
import { gearApplyAnalysisDatasApi } from '@/api/index';
import { Component, Vue, Watch } from 'vue-property-decorator';

@Component({
  name: 'businessStatistics',
  components: {
    InstitutionTopItem,
    CountryDistribution,
    QsRankingDistribution,
    SpecialtyDistribution,
    ApplicationDistribution
  }
})
export default class extends Vue {
  get year() {
    return UserModule.indexSelectYear;
  }

  get language() {
    return AppModule.language;
  }

  get arrowNextLimit() {
    return this.colorTranslateY > -(Math.ceil((this.courseTypeNames.length - 4) / 4) * 56)
  }

  get arrowPreLimit() {
    return this.colorTranslateY < 0
  }

  public colorTranslateY = 0;
  public applyAndSucCount: any = []; // 申请统计
  public countryCount: any = {}; // 国家分布
  public courseTypeCount: any = {}; // 专业分布
  public institutionQsCount: any = []; // 院校QS排名分布
  public institutionTop9List: any = [] // 院校排名前9
  public courseTypeNames: any = [];
  public colorList = ['#50E3C2','#53B997','#6750AA','#F8C541','#294680', '#73B4F8','#7A4388','#E883B9','#00827F','#FF9B47','#386DF1','#999A9F','#B450E3','#D7E350','#616A6B','#EAF2F8','#4A235A','#3498DB' ];

  @Watch('year')
  public onYearChange(year: string) {
    this.gearApplyAnalysisDatas()
  }

  @Watch('language')
  public watchNum(val: any) {
    if(!this.courseTypeCount) {
      return;
    }
    if (val === 'zh' || val === 'zh-hk') {
      this.courseTypeNames = this.courseTypeCount.courseTypeNameCns;
    } else {
      this.courseTypeNames = this.courseTypeCount.courseTypeNameEns;
    }
  }

  public mounted() {
    this.gearApplyAnalysisDatas();
  }

  public preClick() {
    if (this.arrowPreLimit) {
      this.colorTranslateY += 56;
    }
  }

  public nextClick() {
    if (this.arrowNextLimit) {
      this.colorTranslateY -= 56;
    }
  }

  public async gearApplyAnalysisDatas() {
    const { data } = await gearApplyAnalysisDatasApi(this.year);
    this.applyAndSucCount = data.data.applyAndSucCount;
    this.countryCount = data.data.countryCount;
    this.courseTypeCount = data.data.courseTypeCount;
    this.institutionQsCount = data.data.institutionQsCount;
    this.institutionTop9List = data.data.institutionTop9List;
    if (!this.courseTypeCount) {
      this.courseTypeNames = [];
      return;
    }
    if (this.language === 'zh' || this.language === 'zh-hk') {
      this.courseTypeNames = this.courseTypeCount.courseTypeNameCns;
    } else {
      this.courseTypeNames = this.courseTypeCount.courseTypeNameEns;
    }
  }

  public handleSelectYear(year: string) {
    UserModule.SET_INDEX_SELECT_YEAR(year);
  }
}
